(() => {
  // disabled for now
  return;

  // eslint-disable-next-line no-unreachable
  if (
    window.navigator.userAgent.toLowerCase().indexOf('webos') === -1
    && window.navigator.userAgent.toLowerCase().indexOf('tizen') === -1
    && window.navigator.userAgent.toLowerCase().indexOf('bravia') === -1
    && window.navigator.userAgent.toLowerCase().indexOf('smart-tv') === -1
    && window.navigator.userAgent.toLowerCase().indexOf('smarttv') === -1
    && window.navigator.userAgent.toLowerCase().indexOf('smart tv') === -1
    && window.navigator.userAgent.toLowerCase().indexOf('playstation') === -1
    && !window.swinger.storage.get('swinger.debug-console')
  ) {
    return;
  }

  if (window.swinger.user.getId() !== 482281 && !window.swinger.config.isClickDummy) {
    return;
  }

  const wsUri = 'wss://free.blr2.piesocket.com/v3/1?api_key=qTbijiXLXPHZPzQx39nmzY0ypJDOHIc18f4siHwE';
  const websocket = new WebSocket(wsUri);
  const websocketQueue = [];
  const websocketSend = (data) => {
    if (websocket.readyState !== 1) {
      websocketQueue.push(data);
      return;
    }

    websocket.send(JSON.stringify(data));
  };

  /* eslint-disable no-unreachable */
  const consoleLog = console.log;
  const logTotext = (logs) => logs.map((e) => {
    if (e instanceof Error) return `Error: ${e.message}`;

    try {
      if (e instanceof Object) {
        return JSON.stringify(e).slice(1, -1);
      }
      return e;
    } catch (e) {
      return `${e.message}\r\nSee the console for details`;
    }
  }).join('\r\n');
  const log = (...logs) => {
    const text = logTotext(logs);
    document.querySelector('.swinger-debug-console').querySelector('output').textContent += `${text}\r\n`;

    consoleLog(...logs);

    websocketSend({
      action: 'log',
      log: text,
    });
  };

  window.swinger.observer.initialize('.swinger-debug-console', (elem) => {
    // eslint-disable-next-line no-multi-assign
    console.log = console.info = console.error = console.warn = log;

    elem.style.display = '';
  }, false);

  window.swinger.eventHub.register('submit', '.swinger-debug-console__form', (e) => {
    e.preventDefault();

    const elem = window.swinger.eventHub.getTarget(e);
    const command = elem.querySelector('textarea').value;

    if (!command) {
      return;
    }

    // eslint-disable-next-line no-new-func
    const func = new Function(command);
    func();

    websocketSend({
      action: 'execute',
      command,
    });

    elem.querySelector('textarea').value = '';
  });

  window.swinger.eventHub.register('reset', '.swinger-debug-console__form', (e) => {
    const elem = window.swinger.eventHub.getTarget(e);

    elem.querySelector('output').textContent = '';
  });

  window.addEventListener('error', (e) => {
    console.error(e);
  });

  window.swinger.errorLog.forEach((e) => {
    console.error(e.message);
  });

  websocket.onopen = (e) => {
    consoleLog(e);

    websocketSend({
      action: 'log',
      data: logTotext(websocketQueue),
    });
  };
  websocket.onclose = console.info;
  websocket.onmessage = (e) => {
    const data = JSON.parse(e.data);

    switch (data.action) {
      default:
        break;

      case 'execute': {
        // eslint-disable-next-line no-new-func
        const func = new Function(data.command);
        func();
      }
        break;

      case 'log':
        document.querySelector('.swinger-debug-console').querySelector('output').textContent += `${data.log}\r\n`;
        break;
    }
  };
  websocket.onerror = console.error;
})();
